<template>
  <q-checkbox dense>
    <span class="block text-weight-medium">{{ label }}</span>
    <span class="text-neutral-70 text-xs">{{ description }}</span>
  </q-checkbox>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
});
</script>
